import React, { useEffect, useMemo } from 'react';
import { arrayOf, bool, func, node, object, oneOf, shape, string } from 'prop-types';
import classNames from 'classnames';
import { FieldCustomSelect, InlineTextButton, ValidationError } from '..';
import css from './FieldWorkerJobCategory.module.css';
import { languageSelectOptions } from '../../marketplace-custom-config';
import { FormattedMessage, injectIntl } from 'react-intl';
import { findOptionsByFilterLabel, findOptionsForSelectFilter } from '../../util/search';
import config from '../../config';
import { FieldArray } from 'react-final-form-arrays';
import { FiMinus } from 'react-icons/fi';
import { BsPlusLg } from 'react-icons/bs';
import { array } from 'prop-types';
import { ReactComponent as CloseIcon } from '../../assets/svg/close.svg';
import * as validators from '../../util/validators';
import { v4 as uuidv4 } from 'uuid';
import { ReactComponent as InfoIcon } from '../../assets/svg/infoIcon.svg';
// import ReactTooltip from 'react-tooltip';

import { Tooltip as ReactTooltip } from 'react-tooltip';

import './react-tooltip.css';
const textfield = 'textfield';
const errorTextField = 'errorTextField';

const categoryOptions = findOptionsForSelectFilter('category', config.custom.filters);
const subcategoryOptions = findOptionsByFilterLabel('Subcategory', config.custom.filters);

const customLabel = Object.values(languageSelectOptions).reduce((pre, curnt) => {
  pre[curnt.value] = string.isRequired;
  return pre;
}, {});

const nativeLangOptions = Object.keys(customLabel);

const defaultValueForJobCategory = () => ({ category: null, subCategory: null, id: uuidv4() });

const FieldWorkerJobCategoryComponent = props => {
  const {
    rootClassName,
    className,
    errorClassName,
    titleClassName,
    id,
    onCateChange,
    onSubcatChange,
    name,
    userNativeLang,
    intl,
    formApi,
    categoryOptions,
    subcategoryOptions,
    values,
    isRequired,
    fromDescriptionForm,
    fromAdminStaffPage,
    fromSearchPage,
    fromWorkerJobCategoryForm,
    valuesFromForm,
  } = props;

  const lastJobCategory = values[values.length - 1] || defaultValueForJobCategory();
  const addBtnDisabled =
    values.length > 0 ? !lastJobCategory?.category || !lastJobCategory?.subCategory : false;

  // job category
  const jobCategoryLabel = intl.formatMessage({
    id:
      isRequired && !fromSearchPage
        ? 'FieldWorkerJobCateogry.jobCategoryRequiredLabel'
        : 'FieldWorkerJobCateogry.jobCategoryLabel',
  });
  const jobCategoryPlaceholder = intl.formatMessage({
    id: 'FieldWorkerJobCateogry.jobCategoryPlaceholder',
  });
  const jobCategoryRequiredMessage = intl.formatMessage({
    id: 'FieldWorkerJobCateogry.jobCategoryRequired',
  });

  const jobCategoryValidator = isRequired ? validators.required(jobCategoryRequiredMessage) : null;

  // job sub category
  const jobSubcategoryLabel = intl.formatMessage({
    id:
      isRequired && !fromSearchPage
        ? 'FieldWorkerJobCateogry.jobSubcategoryRequiredLabel'
        : 'FieldWorkerJobCateogry.jobSubcategoryLabel',
  });
  const jobSubcategoryPlaceholder = intl.formatMessage({
    id: 'FieldWorkerJobCateogry.jobSubcategoryPlaceholder',
  });

  const jobSubcategoryRequiredMessage = intl.formatMessage({
    id: 'FieldWorkerJobCateogry.jobSubcategoryRequired',
  });

  const jobSubcategoryValidator = isRequired
    ? validators.required(jobSubcategoryRequiredMessage)
    : null;

  const addJobBtnLabel = intl.formatMessage({
    id: 'FieldWorkerJobCateogry.addMoreJobBtn',
  });

  const getSubcategoryOptions = (category, subCategory) => {
    if (!category) return [];
    const cateKey = typeof category === 'string' ? category : category.value ? category.value : '';
    if (!cateKey) return [];
    const subCateKey = `${cateKey}Subcategory`;

    return subcategoryOptions[subCateKey] ? subcategoryOptions[subCateKey] : [];
  };

  const addMoreJobCategory = (isDisabled, event) => {
    event.preventDefault();
    event.stopPropagation();
    if (isDisabled) return;
    const {
      mutators: { push },
    } = formApi;
    push(name, defaultValueForJobCategory());
  };

  const removeJobCategory = (event, indx) => {
    event.preventDefault();
    event.stopPropagation();
    // if (indx <= 0 && isRequired) return;
    const {
      mutators: { remove },
    } = formApi;
    remove(name, indx);
  };
  const removeJobCategoryForWorkerTab = (event, indx) => {
    event.preventDefault();
    event.stopPropagation();
    // if (indx <= 0 && isRequired) return;
    const {
      mutators: { remove },
    } = formApi;
    remove(name, indx);
  };

  const handleCateChange = (fieldName, value) => {
    const cateName = `${fieldName}.category`;
    const subCateName = `${fieldName}.subCategory`;
    formApi.batch(() => {
      formApi.change(cateName, value.value);
      formApi.change(subCateName, null);
    });
    if (typeof onCateChange === 'function') onCateChange(cateName, value);
    if (typeof onSubcatChange === 'function') onSubcatChange(subCateName, null);

    // getSelectedSubCategory({categoryName : value.value});
  };

  const handleSubcateChange = (fieldName, value) => {
    const subCateName = `${fieldName}.subCategory`;
    formApi.change(subCateName, value.value);
    if (typeof onSubcatChange === 'function') onSubcatChange(subCateName, value);

    // getSelectedSubCategory({ subCategoryName: value.value });

    // a.push(value.value)
  };

  const classes = classNames(rootClassName || css.root, className, {
    [errorClassName]: !!errorClassName && hasError,
  });

  const titleClasses = classNames(css.titleWrapper, titleClassName);

  useEffect(() => {
    const {
      getState,
      mutators: { push },
    } = formApi;
    const { values } = getState();
    const currentValue = values[name] || [];
    if (!currentValue.length) {
      push(name, defaultValueForJobCategory());
    }
  }, [lastJobCategory]);

  return (
    <div className={classes} id={id}>
      {!fromDescriptionForm && !fromAdminStaffPage ? (
        <div className={titleClasses}>
          <div className={css.categoryHeadingDiv}>
            <h2 className={css.heading}>
              <FormattedMessage id="FieldWorkerJobCateogry.categoryHeading" />
            </h2>
            <span id="categoryTooltip" className={css.tooltipIcon}>
              <InfoIcon />
            </span>

            <ReactTooltip
              anchorId="categoryTooltip"
              place="right"
              effect="solid"
              clickable={false}
              className={css.categoryTooltip}
              content={<FormattedMessage id="FieldWorkerJobCateogry.categorySubHeading2" />}
            />

            {/* <FormattedMessage id="FieldWorkerJobCateogry.categorySubHeading2" />
          </ReactTooltip> */}
          </div>

          <p className={css.helperText}>
            <FormattedMessage id="FieldWorkerJobCateogry.categorySubHeading1" />
          </p>
          {/* <h3 className={css.subHeading}>
          <FormattedMessage id="FieldWorkerJobCateogry.categorySubHeading2" />
        </h3> */}
        </div>
      ) : null}

      <FieldArray name={name}>
        {({ fields }) => {
          const { value } = fields;
          return fields.map((fieldName, indx) => {
            const { category, subCategory } = value[indx];
            const subCategoryReRenderOn = category
              ? typeof category === 'string'
                ? category
                : category.value
              : '';

            const subcategoryOptionsForField = getSubcategoryOptions(category);
            return (
              <div
                key={fieldName}
                className={classNames(css.fieldParentContainer, {
                  [css.fromDescriptionTab]: !!fromDescriptionForm,
                })}
              >
                {fromWorkerJobCategoryForm ? (
                  <>
                    {indx >= 0 && value[indx].isVerified === false ? (
                      <button
                        type="button"
                        className={css.closeJobBtn}
                        onClick={e => removeJobCategoryForWorkerTab(e, indx)}
                        // disabled
                      >
                        <FiMinus className={css.icon} />
                        <span className={css.text}>
                          {intl.formatMessage({
                            id: 'FieldWorkerJobCateogry.closeJobBtn',
                          })}
                        </span>
                      </button>
                    ) : null}
                  </>
                ) : (
                  <>
                    {value.length === 1 ? null : (
                      <>
                        <button
                          type="button"
                          className={css.closeJobBtn}
                          onClick={e => removeJobCategory(e, indx)}
                          // disabled
                        >
                          <FiMinus className={css.icon} />
                          <span className={css.text}>
                            {intl.formatMessage({
                              id: 'FieldWorkerJobCateogry.closeJobBtn',
                            })}
                          </span>
                        </button>
                      </>
                    )}
                  </>
                )}
                {/* {indx === 0 && isRequired ? null : (
                  <>
                    <button
                      type="button"
                      className={css.closeJobBtn}
                      onClick={e => removeJobCategory(e, indx)}
                      // disabled
                    >
                      <FiMinus className={css.icon} />
                      <span className={css.text}>
                        {intl.formatMessage({
                          id: 'FieldWorkerJobCateogry.closeJobBtn',
                        })}
                      </span>
                    </button>
                  </>
                )} */}
                <div className={css.fieldWrapper}>
                  <FieldCustomSelect
                    id={`${fieldName}.category`}
                    name={`${fieldName}.category`}
                    userNativeLang={userNativeLang}
                    options={Object.values(categoryOptions)}
                    label={fromAdminStaffPage ? null : jobCategoryLabel}
                    placeholder={jobCategoryPlaceholder}
                    className={classNames(css.fieldContainer, textfield)}
                    errorClassName={fromSearchPage || fromAdminStaffPage ? null : errorTextField}
                    validate={fromSearchPage || fromAdminStaffPage ? null : jobCategoryValidator}
                    onChange={handleCateChange.bind(null, fieldName)}
                    disabled={value[indx]?.isVerified}
                    isSearchable={true}
                    valuesFromForm={valuesFromForm}
                  />
                  <FieldCustomSelect
                    id={`${fieldName}.subCategory`}
                    name={`${fieldName}.subCategory`}
                    userNativeLang={userNativeLang}
                    options={subcategoryOptionsForField}
                    label={fromAdminStaffPage ? null : jobSubcategoryLabel}
                    placeholder={jobSubcategoryPlaceholder}
                    className={classNames(css.fieldContainer, textfield)}
                    errorClassName={fromSearchPage || fromAdminStaffPage ? null : errorTextField}
                    noOptionMsgId="FieldWorkerJobCateogry.jobSubcategoryNooptionMsg"
                    reRenderOn={subCategoryReRenderOn}
                    validate={
                      subCategoryReRenderOn && !fromSearchPage && !fromAdminStaffPage
                        ? jobSubcategoryValidator
                        : null
                    }
                    onChange={handleSubcateChange.bind(null, fieldName)}
                    disabled={value[indx]?.isVerified}
                    isSearchable={true}
                    valuesFromForm={valuesFromForm}
                  />
                </div>
              </div>
            );
          });
        }}
      </FieldArray>
      {!fromDescriptionForm && !fromAdminStaffPage ? (
        <div className={css.AddMoreCtgry}>
          <InlineTextButton
            type="button"
            className={css.addMoreJobBtn}
            disabled={addBtnDisabled}
            onClick={e => addMoreJobCategory(addBtnDisabled, e)}
          >
            <BsPlusLg className={css.icon} />
            <span className={css.text}>{addJobBtnLabel}</span>
          </InlineTextButton>
        </div>
      ) : null}
    </div>
  );
};

FieldWorkerJobCategoryComponent.defaultProps = {
  rootClassName: null,
  className: null,
  titleClassName: null,
  errorClassName: null,
  userNativeLang: languageSelectOptions.en.value,
  values: [],
  isRequired: false,
};

FieldWorkerJobCategoryComponent.propTypes = {
  rootClassName: string,
  className: string,
  errorClassName: string,
  titleClassName: string,
  onCateChange: func,
  onSubcatChange: func,
  // Label is optional, but if it is given, an id is also required so
  // the label can reference the input in the `for` attribute
  id: string.isRequired,
  name: string.isRequired,

  formApi: object.isRequired,
  userNativeLang: oneOf(nativeLangOptions).isRequired,
  values: array.isRequired,
  isRequired: bool.isRequired,
};

const FieldWorkerJobCategoryComp = injectIntl(FieldWorkerJobCategoryComponent);

const FieldWorkerJobCategory = props => {
  return (
    <FieldWorkerJobCategoryComp
      {...props}
      categoryOptions={categoryOptions}
      subcategoryOptions={subcategoryOptions}
    />
  );
};

export default FieldWorkerJobCategory;
